// extracted by mini-css-extract-plugin
export default {"Monitoring":"Monitoring_Monitoring__SYcD3","spinnerContainer":"Monitoring_spinnerContainer__j5p2-"};